import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { Table, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ActionsMenu } from '../../common/ActionsMenu';
import { useHistory, useParams } from 'react-router-dom';
import stores from 'cd-eft/models/Stores';
import { UGOSimulateRunoffVM } from './UGOSimulateRunoffVM';
import Draggable from 'react-draggable';
import { Status } from '../UGODesign/UGODesign';
import './UGOSimulateRunoff.scss';
import { mdiInformationOutline } from '@mdi/js';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';

const { ugoDesignStore } = stores.AppStore;

const UGOSimulateRunoffComponent = (props) => {
  const history = useHistory();
  const { projectId }: any = useParams();
  const vm = useRef(new UGOSimulateRunoffVM()).current;

  const Cols = [
    { name: 'pipeline', title: 'Pipeline' },
    { name: 'name', title: 'Name' },
    { name: 'status', title: 'Status' },
    { name: 'requiredQ', title: 'Required\u00A0Q\n(ac-in)' },
    { name: 'actualQ', title: 'Actual Q\n(ac-in)' },
    { name: 'capacity', title: 'Capacity\n(ac-in)' },
    { name: 'velocity', title: 'Velocity\n(ft/sec)' },
    { name: 'length', title: 'Length\n(ft)' },
    { name: 'grade', title: 'Grade\n(%)' },
    { name: 'pressure', title: 'Pressure?' },
    { name: 'diameter', title: 'Diameter\n(in)' },
    { name: 'material', title: 'Material' },
  ];

  useEffect(() => {
    vm.init();
  }, []);

  return (
    <Draggable axis="both" positionOffset={{ x: '-50%', y: '-50%' }} cancel="input,select" allowAnyClick={true}>
      <div className="template-modal ugo-simulate-runoff-modal">
        <ModalHeader tag="h2" className="pb-0 m-2">
          Pipe Network Simulation
        </ModalHeader>
        <ModalBody className="pb-0 mx-2">
          <h3 className="h5 font-weight-bold">Pipe Details</h3>
          <div className="usa-table-container--scrollable reach-table-container">
            <Table className="set-table reach-table m-0">
              <thead className="table-header">
                <tr>
                  {Cols.map((el) => (
                    <th key={`ugo-runoff-${el.name}`} className={el.name === 'status' ? 'text-left pl-4' : ''}>
                      {el.title}
                    </th>
                  ))}
                  <th className="narrow-td action-th">Action</th>
                </tr>
              </thead>
              <tbody>
                {ugoDesignStore.ugoSummaryStations.map((el, idx: number) => (
                  <tr key={'key-UGOSummary-' + idx} className="text-center nobr">
                    <td>{el.pipelineName}</td>
                    <td>{el.reachId}</td>
                    <td>
                      <Status
                        rowData={el}
                        idx={idx}
                        onClick={() => { }}
                        tooltipSide="right"
                        icon={mdiInformationOutline}
                        tooltipMessage={el.errorResponse.errorMessage}
                      />
                    </td>
                    <td>{el.requiredQ ? el.requiredQ.toFixed(2) : ''}</td>
                    <td>{el.actualQ ? el.actualQ.toFixed(2) : ''}</td>
                    <td>{el.capacity ? el.capacity.toFixed(2) : ''}</td>
                    <td>{el.velocity ? el.velocity.toFixed(2) : ''}</td>
                    <td>{el.pipeLength ? el.pipeLength.toFixed(1) : ''}</td>
                    <td>{el.pipeGrade ? (el.pipeGrade * 100).toFixed(2) : ''}</td>
                    <td>{el.onPressure ? 'Yes' : 'No'}</td>
                    <td>{el.diameter}</td>
                    <td>{el.material}</td>
                    {/* Action Column */}
                    <td className={`ugo-action-menu narrow-td action-td`}>
                      <ActionsMenu
                        i={idx}
                        item={el}
                        elementActions={{
                          'Edit Pipeline': {
                            action: () =>
                              history.push(`/design/${projectId}/ugo/${el.pipeAlignedElementParamsId}/design`),
                            disabled: false,
                          },
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {vm.loading ? (
              <div className="p-5 m-5">
                <Loader />
              </div>
            ) : null}
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="row justify-content-end m-0">
            <button className="usa-button usa-button--outline" onClick={ugoDesignStore.onClickSimulateRunoffToggle}>
              Close
            </button>
            <button className="usa-button" onClick={() => { }} disabled={false}>
              Network Simulation
            </button>
            <button className="usa-button m-0" onClick={vm.simulateRunoffSave} disabled={false}>
              Save
            </button>
          </div>
        </ModalFooter>
      </div>
    </Draggable>
  );
};

export const UGOSimulateRunoff = observer(UGOSimulateRunoffComponent);
